import type { EmployeeTodayStatusMeta } from '@/utils/employee-dashboard';

interface ReportStatusBadgeProps {
  meta: EmployeeTodayStatusMeta;
}

export function ReportStatusBadge({ meta }: ReportStatusBadgeProps) {
  return <span className={`mobile-status-badge ${meta.colorClass}`}>{meta.label}</span>;
}
